import { useEffect, useState } from 'react';

/** 作業パネルを押し出し型にする幅・共通バーが `lg:` で切り替わる幅（1024px 以上） */
export const DESKTOP_QUERY = '(min-width: 1024px)';

const matches = (query: string): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : true;

export const useMediaQuery = (query: string): boolean => {
  const [value, setValue] = useState(() => matches(query));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const list = window.matchMedia(query);
    const onChange = () => setValue(list.matches);
    onChange();
    list.addEventListener?.('change', onChange);
    return () => list.removeEventListener?.('change', onChange);
  }, [query]);
  return value;
};

export const useIsDesktop = () => useMediaQuery(DESKTOP_QUERY);
